import React from "react";
import { Box } from "@mui/material";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import UseMobileMode from "../hooks/useMobileMode";
import { styled } from "@mui/material/styles";

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginInlineStart: "8px",
  [theme.breakpoints.up("laptop")]: {
    justifyContent: "flex-end",
    marginBottom: "10px",
  },
}));

export default function CartButton({ onClick, text, price = false }) {
  const isMobile = UseMobileMode();

  return (
    <StyledBox>
      <button
        type="button"
        onClick={onClick}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <span
          style={{
            textDecoration: !price ? "underline" : "none",
            fontWeight: price ? 700 : 400,
            fontSize: price ? 14 : 16,
          }}
        >
          {text}
        </span>
        {!isMobile && (
          <span
            style={{
              background: `url('https://cdn.shopify.com/s/files/1/0563/2737/2823/files/cart-icon-svg-sup.svg?v=1647964709')`,
              backgroundRepeat: "no-repeat",
              height: 24,
              width: 24,
            }}
          ></span>
        )}
        {isMobile && <LocalMallOutlinedIcon />}
      </button>
    </StyledBox>
  );
}
